module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-266.a42cc3fb.jpg";